import { SHOW_ALERT, HIDE_ALERT } from '../actions/alertAction';

const initialState = {
  show: false,
  variant: 'danger',
  message: '',
};

const alertReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_ALERT:
      return {
        ...state,
        show: true,
        variant: action.payload.variant,
        message: action.payload.message,
      };
    case HIDE_ALERT:
      return {
        ...state,
        show: false,
        variant: 'danger',
        message: '',
      };
    default:
      return state;
  }
};

export default alertReducer;
